/**
 * Root App component.
 *
 * Owns authentication, hands the resolved session into the bridge as a prop.
 *
 * REFACTOR STATUS:
 *   - Pure logic (engine, profiler, ML), services, hooks: extracted ✓
 *   - Auth service + LoginPage component: extracted, real Entra ID ✓
 *   - Email-first sign-in with domain restriction: ✓
 *   - Remaining: split ~30 React components from App.bridge.tsx into
 *     @/features/*. See REFACTOR_TODO.md at the root.
 */
import type { ComponentType } from "react";
import type { AuthSession } from "@/types/user";
import { useAuth } from "@hooks/useAuth";
import { LoginPage } from "@/auth/LoginPage";
import BridgeApp from "./App.bridge";

const BridgeAppWithSession = BridgeApp as ComponentType<{
  initialAuth: AuthSession | null;
}>;

export default function App() {
  const { session, isAuthenticated } = useAuth();

  if (!isAuthenticated || !session) {
    return <LoginPage onAuth={() => { /* state syncs through useMsal */ }} />;
  }

  return <BridgeAppWithSession initialAuth={session} />;
}
